module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-e18bbf.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
 ** module id = 912
 ** module chunks = 2
 **/